import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IOffersResponse, IRefundOffersResponse, OffersRequest } from "../../Orchestrator/Types/Index";
import { IAddAncillaryToOfferRequest } from "../../Orchestrator/Types/Interface/IAddOns";
import { IRefundOfferRequest } from "../../Orchestrator/Types/Types/BookingTypes";
import { IAdditionalOffersResponse } from "../../Orchestrator/Types/Types/OffersResponse";

export async function getOffers(
    offerRequest: OffersRequest,
    showErrorToast: boolean = true,
    // Background callers pass false. startLoaderTracking is a GLOBAL counter and
    // the loader only hides at zero, so a request the user did not ask for can
    // both raise the full-screen loader on its own and pin a user-initiated
    // request's loader open until it lands.
    showLoader: boolean = true
): Promise<IApiResponse<IOffersResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getOffers;

    return await apiRequest<IOffersResponse>(endpoint, 'POST', {
        body: JSON.stringify(offerRequest),
    }, "none", undefined, undefined, showLoader, showErrorToast);
}

export async function getOffersForHomepage(offerRequest: OffersRequest): Promise<IApiResponse<IOffersResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getOffers;

    return await apiRequest<IOffersResponse>(endpoint, 'POST', {
        body: JSON.stringify(offerRequest),
    }, "none", undefined, undefined, false, false);
}

export async function getAdditionalOffers(bookingId: string, bookingOfferId: string): Promise<IApiResponse<IAdditionalOffersResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getAdditionalOffers(bookingId, bookingOfferId);
    return await apiRequest<IAdditionalOffersResponse>(endpoint, 'GET');
}

export async function addAncillaryToOffer(
    addAncillaryToOfferRequest: IAddAncillaryToOfferRequest,
    bookingId: string,
    bookingOfferId: string,
    showLoaderForThisRequest: boolean = true
): Promise<IApiResponse<IOffersResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.saveAncillaryToOffer(bookingId, bookingOfferId);

    return await apiRequest<IOffersResponse>(endpoint, 'POST', {
        body: JSON.stringify(addAncillaryToOfferRequest),
    }, "none", undefined, undefined, showLoaderForThisRequest);
}

export async function refundAncillaryFromOffer(fulfillmentIds: string[], bookingId: string): Promise<IApiResponse<IRefundOffersResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.refundAncillaryFromOffer(bookingId);
    const refundOfferRequest: IRefundOfferRequest = {
        fulfillmentIds: fulfillmentIds,
        overruleCode: null,
        refundDate: new Date().toISOString()
    };
    return await apiRequest<IRefundOffersResponse>(endpoint, 'POST', {
        body: JSON.stringify(refundOfferRequest),
    });
}
export async function patchRefundOffer(refundOfferId: string, bookingId: string): Promise<IApiResponse<IOffersResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.patchRefundAncillaryFromOffer(bookingId, refundOfferId);

    return await apiRequest<IOffersResponse>(endpoint, 'PATCH', {
        body: JSON.stringify({ "status": "PROPOSED" }),
    });
}
